import { render } from "./create_service.html?vue&type=template&id=15959668&scoped=true&external"
import script from "./create_service.js?vue&type=script&lang=js&external"
export * from "./create_service.js?vue&type=script&lang=js&external"

import "../../assets/css/new_style.css?vue&type=style&index=0&id=15959668&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15959668"]])

export default __exports__